export class KeyValuePair {
    key: any;
    value: any;
}